import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useLanguage } from "@/contexts/LanguageContext";

interface SiteMeta {
  id: string;
  language_code: string;
  site_title: string;
  site_description: string | null;
  og_title: string | null;
  og_description: string | null;
  og_image: string | null;
  twitter_card: string | null;
  twitter_site: string | null;
}

export const useSiteMeta = () => {
  const { currentLanguage } = useLanguage();

  return useQuery({
    queryKey: ["site-meta", currentLanguage],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_meta")
        .select("*")
        .eq("language_code", currentLanguage)
        .maybeSingle();

      if (error) throw error;
      return data as SiteMeta | null;
    },
  });
};

export const useAllSiteMeta = () => {
  return useQuery({
    queryKey: ["site-meta-all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_meta")
        .select("*")
        .order("language_code");

      if (error) throw error;
      return data as SiteMeta[];
    },
  });
};
